<div class="container py-4">

  <!-- ===============================
       CASH FLOW HERO (PRIMARY)
       =============================== -->
  <div class="row mb-5">
    <div class="col-md-4 col-sm-12 mb-5">
      <div class="card shadow-lg rounded-4 p-4">

        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 class="fw-bold mb-1">Revenue This Month</h3>
            <small class="text-muted">
              Payments collected Online for your portfolio this month
            </small>
          </div>
        </div>
        <!-- Payments Chart -->
        <div class="mt-3">
          <app-payments-chart
            [data]="paymentsChartData$ | async">
          </app-payments-chart>
        </div>

      </div>
    </div>
     <div class="col-md-8 col-sm-12">
      <div class="card shadow-lg rounded-4 p-4 mb-2">

        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 class="fw-bold mb-1">Subscriptions</h3>
            <small class="text-muted">
              Subscriptions currently active and by who
            </small>
          </div>
        </div>

        <div class="table-responsive mt-3">
        <table class="table table-sm align-middle mb-0">
        <thead>
        <tr class="text-muted small">
          <th>User</th>
          <th>Email</th>
          <th>Status</th>
          <th>Amount</th>
          <th>Renews</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let sub of subscriptions$ | async">
        <td class="fw-semibold">{{ sub.userName }}</td>
        <td>{{ sub.email }}</td>
        <td>
          <span
            class="badge"
            [ngClass]="{
              'bg-success': sub.status === 'active',
              'bg-warning': sub.status === 'past_due',
              'bg-secondary': sub.status === 'canceled'
            }">
            {{ sub.status }}
          </span>
        </td>
        <td class="fw-semibold">
          ${{ sub.amount | number:'1.2-2' }}
        </td>
        <td>
          {{ sub.renewsOn | date:'MMM d, y' }}
        </td>
        </tr>
          </tbody>
        </table>
        </div>

      </div>
      <!--Payments-->
       <div class="card shadow-lg rounded-4 p-4">

        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 class="fw-bold mb-1">Payments This Month</h3>
            <small class="text-muted">
              Payments This Month
            </small>
          </div>
        </div>

        <div class="table-responsive mt-3">
        <table class="table table-sm align-middle mb-0">
        <thead>
        <tr class="text-muted small">
          <th>User</th>
          <th>Address</th>
          <th class="d-none d-md-block">Status</th>
          <th>Amount</th>
          <th>Payment Date</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let payment of payments$ | async">
        <td class="fw-semibold">{{ payment.userName }}</td>
        <td >{{ payment.rentalAddress }}</td>
        <td class="d-none d-md-block">
          <span
            class="badge"
            [ngClass]="{
              'bg-success': payment.status === 'succeeded',
              'bg-warning': payment.status === 'pending',
              'bg-secondary': payment.status === 'canceled'
            }">
            {{ payment.status }}
          </span>
        </td>
        <td class="fw-semibold">
          ${{ payment.amount / 100 | number:'1.2-2' }}
        </td>
        <td class="fw-semibold">
          {{ payment.createdAt | date:'MMM d h:mm a'}}
        </td>
        </tr>
          </tbody>
        </table>
        </div>

      </div>
    </div>
  </div>

  <!-- ===============================
       REVENUE KPIs (CONTEXT)
       =============================== -->
  <div class="row g-4 mb-5">

    <div class="col-12 col-md-4">
      <div class="card shadow-sm rounded-4 p-4 text-center">
        <div class="text-muted text-uppercase small mb-2">
          Revenue This Month
        </div>
        <div class="display-6 fw-bold">
          ${{ paymentsThisMonth$ | async | number:'1.0-0' }}
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="card shadow-sm rounded-4 p-4 text-center">
        <div class="text-muted text-uppercase small mb-2">
          Total Rentals
        </div>
        <div class="display-6 fw-bold">
          {{ (rentalsWithLandlord$ | async)?.length }}
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="card shadow-sm rounded-4 p-4 text-center">
        <div class="text-muted text-uppercase small mb-2">
          Total Tenants
        </div>
        <div class="display-6 fw-bold">
          {{ (tenantsWithRental$ | async)?.length }}
        </div>
      </div>
    </div>

  </div>

  <!-- ===============================
       PORTFOLIO HEALTH
       =============================== -->
  <div class="row g-4 mb-5">
    <div class="col-12 col-lg-6">
      <div class="card shadow-sm rounded-4 p-4 h-100">
        <h5 class="fw-semibold mb-3">Portfolio Health</h5>

        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Leases Ending Soon</span>
          <strong>{{ (leasesEndingSoon$ | async)?.length }}</strong>
        </div>

        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Active Rentals</span>
          <strong>{{ (rentalsWithLandlord$ | async)?.length }}</strong>
        </div>

        <div class="d-flex justify-content-between">
          <span class="text-muted">Active Tenants</span>
          <strong>{{ (tenantsWithRental$ | async)?.length }}</strong>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6">
      <div class="card shadow-sm rounded-4 p-4 h-100">
        <h5 class="fw-semibold mb-3">Quick Actions</h5>

        <div class="row g-3">
          <div class="col-6">
            <button
              class="btn btn-outline-primary w-100"
              (click)="goToTenants()">
              Tenants
            </button>
          </div>

          <div class="col-6">
            <button
              class="btn btn-outline-secondary w-100"
              (click)="goToRentals()">
              Rentals
            </button>
          </div>

          <div class="col-6">
            <button
              class="btn btn-outline-success w-100"
              (click)="goToApplications()">
              Applications
            </button>
          </div>

          <div class="col-6">
            <button
              class="btn btn-outline-warning w-100"
              (click)="goToLeases()">
              Leases
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- ===============================
       RENTALS TABLE (SECONDARY)
       =============================== -->
  <div class="card shadow-sm rounded-4 mb-5">
    <div class="card-body p-4">
      <h5 class="fw-semibold mb-3">Rentals</h5>

      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Address</th>
              <th>Landlord</th>
              <th>Bedrooms</th>
              <th>Bathrooms</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rental of rentalsWithLandlord$ | async">
              <td>{{ rental.address }}</td>
              <td>{{ rental.landlordName }}</td>
              <td>{{ rental.bedrooms }}</td>
              <td>{{ rental.bathrooms }}</td>
              <td>${{ rental.price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- ===============================
       TENANTS TABLE (SECONDARY)
       =============================== -->
  <div class="card shadow-sm rounded-4">
    <div class="card-body p-4">
      <h5 class="fw-semibold mb-3">Tenants</h5>

      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Rental Address</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tenant of tenantsWithRental$ | async">
              <td>{{ tenant.firstName }} {{ tenant.lastName }}</td>
              <td>{{ tenant.email }}</td>
              <td>{{ tenant.rentalAddress }}</td>
              <td>
                <span class="badge bg-secondary">
                  {{ tenant.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

</div>
